import React from "react";
import { Col, FloatingLabel, Form, Row } from "react-bootstrap";
import DatePicker from "../ui/DatePicker";

interface StandardNoteState {
  noteDate: string;
  setNoteDate: (date: string) => void;
  note: string | undefined;
  setNote: (note: string) => void;
}

const StandardNote = ({ noteDate, setNoteDate, note, setNote }: StandardNoteState) => {
  return (
    <>
      <Row className="mb-3 mx-0 px-0">
        <Col xs={12}>
          <FloatingLabel controlId="floatingInput" label="Note">
            <Form.Control
              as="textarea"
              type="textarea"
              placeholder="Note"
              value={note}
              className="form-control-enabled"
              onChange={(e) => setNote(e.target.value)}
            />
          </FloatingLabel>
        </Col>
      </Row>
      <Row className="mx-0 px-0">
        <Col xs={6}>
          <DatePicker label="Note Date" currentValue={noteDate} setCurrentValue={setNoteDate} hasMaxDate={true} />
        </Col>
      </Row>
    </>
  );
};

export default StandardNote;
